import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, PureComponent } from 'react';
import { Consumer } from './portal-provider';

var portalTarget = function portalTarget(name) {
  return function (PortalTargetComponent) {
    var PortalTargetCore = /*#__PURE__*/function (_Component) {
      _inherits(PortalTargetCore, _Component);

      var _super = _createSuper(PortalTargetCore);

      function PortalTargetCore(props) {
        var _this;

        _classCallCheck(this, PortalTargetCore);

        _this = _super.call(this, props);
        _this.state = {
          children: []
        };
        props.portalConnector.registerTarget(name, _assertThisInitialized(_this));
        return _this;
      }

      _createClass(PortalTargetCore, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.props.portalConnector.removeTarget(name, this);
        }
      }, {
        key: "updateChildren",
        value: function updateChildren(children) {
          this.setState({
            children: children
          });
        }
      }, {
        key: "render",
        value: function render() {
          var _context;

          var clones = _mapInstanceProperty(_context = React.Children).call(_context, this.state.children, function (child, index) {
            return /*#__PURE__*/React.cloneElement(child, {
              index: index
            });
          });

          return /*#__PURE__*/React.createElement(PortalTargetComponent, null, clones);
        }
      }]);

      return PortalTargetCore;
    }(Component);

    var PortalTarget = /*#__PURE__*/function (_PureComponent) {
      _inherits(PortalTarget, _PureComponent);

      var _super2 = _createSuper(PortalTarget);

      function PortalTarget() {
        _classCallCheck(this, PortalTarget);

        return _super2.apply(this, arguments);
      }

      _createClass(PortalTarget, [{
        key: "render",
        value: function render() {
          var _this2 = this;

          return /*#__PURE__*/React.createElement(Consumer, null, function (portalConnector) {
            return /*#__PURE__*/React.createElement(PortalTargetCore, _extends({}, _this2.props, {
              portalConnector: portalConnector
            }));
          });
        }
      }]);

      return PortalTarget;
    }(PureComponent);

    PortalTarget.displayName = 'portalTarget';
    return PortalTarget;
  };
};

export default portalTarget;